module.exports = __webpack_public_path__ + "img/SMT_31_Ms_Clarice_Woon_Lai_Lin.6f7235f2.jpg";